import { render, staticRenderFns } from "./ReqAbiertasReportComponent.vue?vue&type=template&id=da119830&"
import script from "./ReqAbiertasReportComponent.vue?vue&type=script&lang=js&"
export * from "./ReqAbiertasReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports